module.exports = __webpack_public_path__ + "static/sport/slide2.ef574f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/trea/slide2.png
// module id = IkQc
// module chunks = 0